import { render, staticRenderFns } from "./InboundDeliveryViewEdit.vue?vue&type=template&id=6cf01dfe&scoped=true&"
import script from "./InboundDeliveryViewEdit.vue?vue&type=script&lang=js&"
export * from "./InboundDeliveryViewEdit.vue?vue&type=script&lang=js&"
import style0 from "./InboundDeliveryViewEdit.vue?vue&type=style&index=0&id=6cf01dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf01dfe",
  null
  
)

export default component.exports